import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router, UrlSegment } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiResponseModel } from 'src/app/models/shared-model';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ProductsService } from 'src/app/services/products.service';
import { HeaderbreadcrumbService } from 'src/app/services/shared/headerbreadcrumb.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';



import { SharedService } from 'src/app/services/shared-service.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SweetAlertOptions } from 'sweetalert2';
import { take } from 'rxjs';

@Component({
  selector: 'app-website-header',
  templateUrl: './website-header.component.html',
  styleUrls: ['./website-header.component.css']
})
export class WebsiteHeaderComponent implements OnInit {


  isDropdownOpen: boolean = false;
  isLoggedin: boolean = false;
  isCategoryDropdownOpen: boolean = false;
  isKnowledgeCenterDropdownOpen: boolean = false;
  isNewsAndInsightsDropdownOpen: boolean = false;
  isHealthCenterDropdownOpen: boolean = false;
  limitedNotifications: any[] = [];
  showNotificationDropdown = false;
  userId!: string;
  allNotifications: any[] = [];
  noData: boolean = false;
  roleName!: string;
  searchTerm: string = '';
  userName: string = '';
  categories: any = [];
  products: any = [];
  oems: any = [];
   distributors:any=[];
 webinars: any = [];
  filteredCategories: any = [];
  showDropdown: boolean = false;
  items: any[] = [];
  randomData: string[] = ["Anvesh", "aleti"];
  brands: any = [
    { id: 1, name: 'Brand 1' },
    { id: 2, name: 'Brand 2' },
    { id: 3, name: 'Brand 3' },
    { id: 4, name: 'Brand 4' },
    { id: 5, name: 'Brand 5' }
  ];
  KnowledgeCenterList: string[] = ['Webinars', 'Conferences/ CME', 'Blogs & Community', 'E-Magazines', 'Journals'];
  NewsAndInsightsList: string[] = ['Latest News', 'Events'];
  HealthCenterList: string[] = ['Doctors', 'Hospitals', 'Labs', 'Clinics'];
  otherDropDownsOpen: boolean = false;
  isDisableMenuInCurrentPage: boolean = false;
  isDeviceTypeApple: boolean = false;

  constructor(private http: HttpClient,
    private sharedService: SharedService, private translateService: TranslateService, private authService: AuthService, private localStorageService: LocalStorageService, private categoryService: CategoryService, private sweetAlertService: SweetAlertService, private router: Router, private productsservice: ProductsService, private headerBreadCrumbService: HeaderbreadcrumbService, private render: Renderer2,
    private activatedRoute: ActivatedRoute) {
    window.addEventListener('scroll', this.scrollEvent, true);
  }
  scrollEvent = (event: any): void => {
    const path = event.composedPath();
    const hoveredElement = path[0];
    const tagName = hoveredElement.tagName;
    if (tagName === 'INPUT') {
      return;
    }

    const dropdownElements = document.querySelectorAll('.forScrolling, .forScrollingMobile');
    let isScrollInsideDropdown = false;

    dropdownElements.forEach((dropdownElement) => {
      if (dropdownElement.contains(hoveredElement)) {
        isScrollInsideDropdown = true;
      }
    });

    if (!isScrollInsideDropdown && this.showDropdown) {
      this.showDropdown = false;
    }
  };

  toggleDropdown(open: boolean): void {
    this.isDropdownOpen = open;
  }
  isLanguageDropdownOpen: boolean = false;
  selectedLanguage: string = 'en';
  isDisableEvents = false;


  ngOnInit(): void {
    this.findDeviceType();
    this.isLoggedIn();
    this.fetchCategories();
    this.roleName = this.localStorageService.getItem('roleName');

    this.localStorageService.getUserDetails()?.subscribe(userDetails => {
      this.userName = userDetails?.userName;
      this.userId = userDetails?.userId;
    });
    if (this.userId) {
      this.fetchNotifications();
    }

  }

  myAccountRoutes: string = this.roleName === 'SUPER_ADMIN' ? '/dashboard/super-admin' : this.roleName === 'OEM' ? '/dashboard/oem' : '/dashboard/distributor';

  onHealthCenterSelect(health: string): void {
    let route: string;
    switch (health) {
      case 'Doctors':
        route = '/doctors';
        break;
      case 'Hospitals':
        route = '/hospitals';
        break;
      case 'Labs':
        route = '/labs';
        break;
      default:
        route = '/clinics';
        break;
    }
    this.router.navigate([route], { state: { health } });
  }

  toggleLanguageDropdown(open: boolean): void {
    if (this.isDisableEvents) {
      this.isDisableEvents = false;
      return;
    }
    this.isLanguageDropdownOpen = open;
  }
  isMobileLanguageDropDown() {
    if (this.isDisableEvents) {
      this.isDisableEvents = false;
      return;
    }
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen
  }
  fetchNotifications() {
    const pageNumber = 0;
    const pageSize = 10;
    this.sharedService.getNotifications(this.userId, pageNumber, pageSize).subscribe(
      (response) => {
        if (response?.data) {
          this.allNotifications = response.data;
          this.limitedNotifications = this.allNotifications.slice(0, 9);
        }
        if (this.allNotifications.length == 0) {

          this.noData = true;
        }
        else {
          this.noData = false;
        }
      },
      (error) => {
        this.noData = true;

      }
    );
  }

  toggleNotifications(showDropdown: boolean) {
    this.showNotificationDropdown = showDropdown;
  }


  openAllNotifications() {

    if (this.roleName === 'SUPER_ADMIN') {
      this.router.navigate(['dashboard/super-admin/notifications']);
    }
    else if (this.roleName === 'OEM') {
      this.router.navigate(['dashboard/oem/notifications']);
    } else if (this.roleName === 'DISTRIBUTOR') {
      this.router.navigate(['dashboard/distributor/notifications']);
    }
    else if (this.roleName === 'USER') {


      this.router.navigate(['user/home'], { queryParams: { tabName: 'notifications' } });
    }


    this.showNotificationDropdown = false;
  }

  selectLanguage(language: string): void {
    this.selectedLanguage = language;
    this.translateService.setDefaultLang(language)
    this.isDisableEvents = true;
    this.isLanguageDropdownOpen = false;
  }

  logout(): void {
    this.sweetAlertService.showConfirmation(
      'Logout',
      'Are you sure you want to logout?',
      'Yes',
      'No'
    ).then((result) => {
      if (result.isConfirmed) {


        this.userName = ''
        this.authService.onLogout();
      }
    });
  }
  isLoggedIn() {
    if (this.authService.isAuthenticated()) {
      this.isLoggedin = true;
    }
  }
  navigateByRole() {
    this.authService.navigateByRole(this.localStorageService.getItem('roleName'));
  }
  navigateMyAccountOptionsByRole(routeName: string, breadcrumbName: string): void {
    this.authService.navigateMyAccountOptionsByRole(this.localStorageService.getItem('roleName'), routeName);
    this.headerBreadCrumbService.setHeaderBreadcrumbs([breadcrumbName])
  }

  fetchCategories() {
    this.categoryService.getAllParentCategories().subscribe(
      (response: ApiResponseModel<any[]>) => {
        this.categories = response.data;
      },
      (error) => {

      }
    );
  }
  toggleCategoryDropdown(open: boolean): void {
    if (this.isCategoryDropdownOpen !== open) {
      this.otherDropDownsOpen = open
      this.isCategoryDropdownOpen = open;
      if (this.otherDropDownsOpen) {
        this.isKnowledgeCenterDropdownOpen = false;
        this.isNewsAndInsightsDropdownOpen = false;
        this.isHealthCenterDropdownOpen = false;
      }
    }
  }

  onCategorySelect(category: any): void {
    this.isCategoryDropdownOpen = false;
    const currentUrl = this.router.url;
    const newUrl = `/category/${category.id}`;
    if (currentUrl.includes('/category/')) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/category', category.id], {
          state: { category: category, isViewAll: false }
        });
      });
    } else {
      this.router.navigate(['/category', category.id], {
        state: { category: category, isViewAll: false }
      });
    }
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  closeDropdownMenuInCurrentPage() {
    this.isDisableMenuInCurrentPage = true;
  }

  toggleKnowledgeCenterDropdown(open: boolean): void {
    if (this.isDisableMenuInCurrentPage) {
      this.isDisableMenuInCurrentPage = false;
      this.isKnowledgeCenterDropdownOpen = false;
      this.isHealthCenterDropdownOpen = false;
      this.isNewsAndInsightsDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
      return;
    }
    this.otherDropDownsOpen = open
    this.isKnowledgeCenterDropdownOpen = open;
    if (this.otherDropDownsOpen) {
      this.isHealthCenterDropdownOpen = false;
      this.isNewsAndInsightsDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
    }
  }

  toggleHealthCenterDropdown(open: boolean): void {
    if (this.isDisableMenuInCurrentPage) {
      this.isDisableMenuInCurrentPage = false;
      this.isHealthCenterDropdownOpen = false;
      this.isKnowledgeCenterDropdownOpen = false;
      this.isNewsAndInsightsDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
      return;
    }
    this.otherDropDownsOpen = open
    this.isHealthCenterDropdownOpen = open;
    if (this.otherDropDownsOpen) {
      this.isKnowledgeCenterDropdownOpen = false;
      this.isNewsAndInsightsDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
    }
  }

  toggleNewsAndInsightsDropdown(open: boolean): void {
    if (this.isDisableMenuInCurrentPage) {
      this.isDisableMenuInCurrentPage = false;
      this.isNewsAndInsightsDropdownOpen = false;
      this.isKnowledgeCenterDropdownOpen = false;
      this.isHealthCenterDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
      return;
    }
    this.otherDropDownsOpen = open
    this.isNewsAndInsightsDropdownOpen = open;
    if (this.otherDropDownsOpen) {
      this.isKnowledgeCenterDropdownOpen = false;
      this.isHealthCenterDropdownOpen = false;
      this.isCategoryDropdownOpen = false;
    }
  }

  search(searchTerm: string): void {

    if (searchTerm.length <= 2) {
      this.showDropdown = false;
      return;
    }

    this.products = [];
    this.oems = [];
    this.distributors =[];
    this.filteredCategories = [];
    this.webinars = [];

    this.productsservice.searchitemsbykeyword(searchTerm).subscribe(
      response => {

        if (response?.data && response.data.length > 0) {
          const newProducts: any[] = [];
          const newOems: any[] = [];
          const newDistributors:any [] =[];
          const newCategories: any[] = [];
          const newWebinars: any[] = [];

          response.data.forEach((item: any) => {
            if (item?.type === "Product") newProducts.push(item);
            else if (item?.type === 'OEM') newOems.push(item);
            else if (item?.type === 'DISTRIBUTOR') newDistributors.push(item);
            else if (item?.type === 'Category') newCategories.push(item);
            else if (item?.type === 'Webinar') newWebinars.push(item);
          });

          this.products = newProducts;
          this.oems = newOems;
          this.distributors = newDistributors;
          this.filteredCategories = newCategories;
          this.webinars = newWebinars;
         
          
  
          this.showDropdown = this.products.length > 0 || this.oems.length > 0 || this.distributors.length > 0 || this.webinars.length > 0 || this.filteredCategories.length > 0;

        } else {
          this.showDropdown = false;
        }
      },
      error => {

        this.showDropdown = false;
      }
    );
  }

  navigateTo(route: string[]): void {
    this.router.navigate(route).then(() => {
      window.location.reload();
    });
  }

  navigateToBrandProfile(oemId: string) {
    const navigationExtras: NavigationExtras = {
      queryParams: { type: 'brand' }
    };
    this.router.navigate([`/brands/brand-profile/${oemId}`], navigationExtras).then(() => {
      // window.location.reload();
    });
  }
  navigateToDistributorProfile(distributorId: string) {
    const navigationExtras: NavigationExtras = {
        queryParams: { type: 'distributor' }
    };
    this.router.navigate([`/website-distributor/distributor-profile/${distributorId}`], navigationExtras).then(() => {
      window.location.reload();
    });
  }

  responsiveMoreOptions = false;
  isResponsiveSearch = false;
  responsiveMore() {
    this.responsiveMoreOptions = !this.responsiveMoreOptions;
    document.body.style.overflow = this.responsiveMoreOptions ? 'hidden' : 'auto';

  }

  responsiveSearch() {
    this.isResponsiveSearch = !this.isResponsiveSearch;
  }

  closeResponsiveBar() {
    this.responsiveMoreOptions = false
    this.insideMenu = false;
    document.body.style.overflow = this.responsiveMoreOptions ? 'hideen' : 'auto';
  }
  insideMenu: boolean = false;
  isInsideMenu() {
    this.insideMenu = true;
  }
  closeTheHamburgerMenu() {
    if (this.insideMenu) {
      this.insideMenu = false;
      return;
    }
    this.closeResponsiveBar();
  }

  barActiveContent: any[] = [];
  barOptions(name: string) {
    switch (name) {
      case 'products':
        const index = this.barActiveContent.indexOf('products');
        if (index > -1) {
          this.barActiveContent.splice(index, 1);
        }
        else {
          this.barActiveContent.push('products');
        }
        break;

      case 'healthServices':
        const indexHealth = this.barActiveContent.indexOf('healthServices');
        if (indexHealth > -1) {
          this.barActiveContent.splice(indexHealth, 1);
        }
        else {
          this.barActiveContent.push('healthServices');
        }
        break;

      case 'newsSights':
        const indexNews = this.barActiveContent.indexOf('newsSights');


        if (indexNews > -1) {
          this.barActiveContent.splice(indexNews, 1);
        }
        else {
          this.barActiveContent.push('newsSights');
        }
        break;

      case 'knowledgeCenter':
        const indexKnowledge = this.barActiveContent.indexOf('knowledgeCenter');


        if (indexKnowledge > -1) {
          this.barActiveContent.splice(indexKnowledge, 1);
        }
        else {
          this.barActiveContent.push('knowledgeCenter');
        }
        break;

      default:
        break;
    }
  }

  navigateToWebinar(arg0: any) {
    this.router.navigate([`/webinars/view/${arg0}`]).then(() => {
      window.location.reload();
    });
  }

  navigateToNews(news: string) {
    const route = news === 'Latest News' ? '/news' : '/events';
    if (this.router.url !== route) {
      this.router.navigate([route], { state: { news: news } });
    }
  }
  navigateToSupport() {
    if (this.isLoggedin) {
      this.roleName = this.localStorageService.getItem('roleName');
      if (this.roleName === 'USER') {
        this.router.navigate(['/user/home'], { queryParams: { tabName: 'support' } });

      } else if (this.roleName === 'OEM') {
        this.router.navigate(['/dashboard/oem/support']);
      } else if (this.roleName === 'DISTRIBUTOR') {
        this.router.navigate(['/dashboard/distributor/support']);
      } else if (this.roleName === 'SUPER_ADMIN') {
        this.router.navigate(['/dashboard/super-admin/support-tickets']);
      }
    }
    else {
      let options: SweetAlertOptions = {

        html: window.location.hostname === 'localhost' || window.location.hostname === 'dev.medworldexpo.com' || window.location.hostname === 'qa.medworldexpo.com' ?
          'For any queries, please contact us at <br> <a class="anchorHTMLTag" href="mailto:info-test@digiworldexpo.com" style="color:blue; text-decoration:none;">info-test@digiworldexpo.com</a>' :
          'For any queries, please contact us at <br> <a class="anchorHTMLTag" href="mailto:info@digiworldexpo.com" style="color:blue; text-decoration:none;">info@digiworldexpo.com</a>',
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor: 'white',
        showCancelButton: false,
        confirmButtonText: 'OK',
        confirmButtonColor: 'rgba(13, 135, 200, 1)',

      }
      this.sweetAlertService.showAlertWithPromise(options).then((t: any) => {

      })
    }
  }
  onSignInClick() {
    this.authService.setLastVisitedUrl(this.router.url);
    this.router.navigate(['/login']);
  }
  openGmail() {
    const recipientEmail = 'info@digiworldexpo.com';
    const subject = 'Hello';
    const body = 'I would like to connect with you.';
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, '_self');
  }

  findDeviceType() {
    const deviceType = navigator.userAgent.toLowerCase();
    if (deviceType.includes('iphone') || deviceType.includes('ipad') || deviceType.includes('ipod') || deviceType.includes('macintosh')) {
      this.isDeviceTypeApple = true;
    } else if (deviceType.includes('android')) {
      this.isDeviceTypeApple = false;
    } else {
      this.isDeviceTypeApple = false;
    }
  }

  navigateToCustomerProfile() {
    this.router.navigate(['/user/home'], { queryParams: { tabName: 'myProfile' } });
  }

}